<template>
    <div id="app">
        <router-view></router-view>
        <b-button class="contact_us_btn" pill v-b-modal.modal-contact-us>
            <img class="brand-img bsnav-brand-center responsive" src="/static/images/icons/contact.svg" width="30"
                 alt="">
        </b-button>
        <b-modal
                id="modal-contact-us"
                ref="modal"
                size="lg"
        >
            <template v-slot:modal-header="{ close }">
                <h5 style="color: black">{{$t('message.contact_us')}}</h5>
                <b-button size="sm" variant="outline-danger" @click="close()">
                    <i class="fas fa-close"></i>
                </b-button>
            </template>
            <form ref="form" @submit.stop.prevent="handleOk">
                <div class="row">
                    <div class="col-7">
                        <b-form-group label-cols="4" label-cols-lg="4"
                                      id="name-input" :label="$t('message.your_fullname')"
                                      invalid-feedback="This is a required field and must be at least 3 characters."
                                      :description="$t('message.name')" label-for="name-input">
                            <b-form-input
                                    id="name-input"
                                    name="name-input"
                                    v-model="form_mail.name"
                                    :state="$v.form_mail.name.$dirty ? !$v.form_mail.name.$error : null"
                                    aria-describedby="input-1-live-feedback"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-5">
                        <b-form-group id="lastname-input" :description="$t('message.lastname')" label-for="name-input"
                                      invalid-feedback="This is a required field and must be at least 3 characters.">
                            <b-form-input
                                    id="lastname-input"
                                    name="lastname-input"
                                    :state="$v.form_mail.lastname.$dirty ? !$v.form_mail.lastname.$error : null"
                                    v-model="form_mail.lastname"
                                    aria-describedby="input-1-live-feedback"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <b-form-group label-cols="3" label-cols-lg="2" class="input_padding_message"
                              id="name-input" :label="$t('message.organization')" label-for="name-input">
                    <b-form-input
                            id="name-input"
                            name="name-input"
                            v-model="form_mail.organization"
                            aria-describedby="input-1-live-feedback"
                    ></b-form-input>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="2" class="input_padding_message"
                              id="name-input" :label="$t('message.your_email')" label-for="name-input">
                    <b-form-input
                            id="name-input"
                            name="name-input"
                            v-model="form_mail.email"
                            aria-describedby="input-1-live-feedback"
                    ></b-form-input>

                    <b-form-invalid-feedback id="input-1-live-feedback">
                        This is a required field and must be at least 3 characters.
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="2" class="input_padding_message"
                                             :state="$v.form_mail.phone.$dirty ? !$v.form_mail.phone.$error : null"
                                              id="name-input" :label="$t('message.your_phone')" label-for="name-input"
                                              invalid-feedback="This is a required field and must be at least 3 characters.">
                    <the-mask mask="+998(##) ###-##-##" class="form-control" placeholder="+998(##) ###-##-##" v-model="form_mail.phone"/>
            </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" class="input_padding_message"
                              id="name-input" :label="$t('message.message')" label-for="name-input"
                              invalid-feedback="This is a required field.">
                    <b-form-textarea
                            id="textarea"
                            v-model="form_mail.message"
                            :state="$v.form_mail.message.$dirty ? !$v.form_mail.message.$error : null"
                            rows="3"
                            max-rows="6"
                    ></b-form-textarea>
                </b-form-group>
                <div class="g-recaptcha" data-sitekey="6LdhYL0UAAAAALp_Rd_MZH_M86n2QIlcxtDIRKFj"></div>
            </form>
            <template v-slot:modal-footer>
                <vue-recaptcha
                        ref="recaptcha"
                        size="invisible"
                        :sitekey="sitekey"
                        @verify="handleSubmit"
                        @expired="onCaptchaExpired"
                />
                <b-row>
                    <b-col align-self="center">
                        <b-button class="mt-2 right" size="sm" variant="danger" @click="resetModal">
                            {{$t('message.close')}}
                        </b-button>
                    </b-col>
                    <b-col align-self="end">
                        <b-button class="mt-2" size="sm" variant="success" @click="handleOk">{{$t('message.send')}}
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>
    </div>
</template>
<script src="https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit" async defer></script>
<script>
    import {validationMixin} from 'vuelidate'
    import {required, minLength, numeric, email} from 'vuelidate/lib/validators'
    import {postSendMessage} from './api/index'
    import {mapGetters} from "vuex";
    import VueRecaptcha from 'vue-recaptcha'
    import {TheMask} from 'vue-the-mask'
    export default {
        name: 'app',
        mixins: [validationMixin],
        components: { VueRecaptcha, TheMask },
        computed: {
            ...mapGetters(["selectedLocale"])
        },
        data() {
            return {
                sitekey: '6LdhYL0UAAAAALp_Rd_MZH_M86n2QIlcxtDIRKFj',
                name: '',
                nameState: null,
                submittedNames: [],
                form_mail: {
                    name: null,
                    lastname: null,
                    phone: null,
                    email: null,
                    message: null
                }
            }
        },
        validations: {
            form_mail: {
                name: {
                    required,
                    minLength: minLength(3)
                },
                lastname: {
                    required,
                    minLength: minLength(3)
                },
                lastname: {
                    required,
                    minLength: minLength(3)
                },
                email: {
                    minLength: minLength(3),
                    email
                },
                phone: {
                    required,
                    minLength: minLength(3)
                },
                message: {
                    required,
                    minLength: minLength(3)
                }
            }
        },
        methods: {
            checkFormValidity() {
                const valid = this.$refs.form.checkValidity()
                this.nameState = valid ? 'valid' : 'invalid'
                return valid
            },
            resetModal() {
                this.form_mail = {
                    name: null,
                    lastname: null,
                    phone: null,
                    email: null,
                    message: null
                }
                this.$refs.modal.hide()
            },
            handleOk(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()
                // Trigger submit handler
                this.handleSubmit()
            },
            handleSubmit(recaptchaToken) {
                 this.$v.form_mail.$touch()
                 if (this.$v.form_mail.$anyError) {
                     return
                 }
                this.form_mail.fullname = this.form_mail.name + ' ' + this.form_mail.lastname
                this.form_mail.phonenumber = this.form_mail.phone
                this.form_mail.recaptchaToken = recaptchaToken
                postSendMessage(this.selectedLocale.suffix.toLowerCase(), this.form_mail).then(res => {
                   this.makeToast('success', 'successful_message')
                }).catch(() => {
                    this.makeToast('error', 'error_message')
                })

                // Push the name to submitted names
                this.submittedNames.push(this.name)
                // Hide the modal manually
                this.$nextTick(() => {
                    this.$refs.modal.hide()
                })
            },
            validate () {
                // тут можно добавить проверку на валидацию
                // например, с помощью vee validate
                // если с валидацией наших полей все хорошо, запускаем каптчу
//                this.$refs.recaptcha.execute()
            },
            onCaptchaExpired () {
//                this.$refs.recaptcha.reset()
            },
            makeToast(variant = null, text = null) {
                this.$bvToast.toast(this.$t('message.'+text), {
                    title: this.$t('message.messages'),
                    variant: variant,
                    solid: true
                })
            }
        }
    }
</script>

<style>
    #app {
        /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
         -webkit-font-smoothing: antialiased;
         -moz-osx-font-smoothing: grayscale;
         text-align: center;
         color: #2c3e50;
         !*margin-top: 60px;*!*/
        /*     display: list-item;
             width: 100%;*/
    }

    html {
        /*display: table-caption;*/
    }

    .contact_us_btn {
        position: fixed;
        bottom: 1rem;
        right: 1rem;
        z-index: 10000;
        color: #fff;
        -webkit-box-shadow: 0 0 8px rgba(8, 58, 94, 0.6);
        background-color: #fff !important;
        padding-top: 13px !important;
        padding-bottom: 9px !important;
        border-color: #17a2b8 !important;
        padding-right: 15px !important;
    }

    .input_padding_message .col input, .input_padding_message .col textarea {
        width: 97%;
        margin-left: 1rem;
    }
</style>
